// extracted by mini-css-extract-plugin
export var loadingSpinner = "_1n-0";
export var spinnerContainer = "_1n-1";